import {getRandomString, promisifiedSocketEmit} from "../helpers";
import {getSocket, connectSocket} from "../sockets";

const MAYA = {
  isAuthenticated() {
    return !!localStorage.getItem('otc_token')
  },
  getAccessToken() {
    return localStorage.getItem('otc_token')
  },
  getAuthToken(){
    return localStorage.getItem('auth_token')
  },
  getAccounts(){
    let result = null;
    let accounts = localStorage.getItem('accounts');
    if(!accounts) return result;

    try {
      result = JSON.parse(accounts)
    } catch (e) {
      result = null;
    }

    return result;
  },
  getPhoneNumber(){
    const accounts = MAYA.getAccounts();
    if(!accounts) return null;

    return accounts[0] && accounts[0].value
  },
  getCredentials(){
    return {
      otc_token: MAYA.getAccessToken(),
      auth_token: MAYA.getAuthToken()
    }
  },
  async logout() {
    const {getStore} = await import('../main');
    const store = getStore();

    localStorage.removeItem('otc_token');
    localStorage.removeItem('auth_token');

    const {closeTimeoutPopup} = await import('../store/timer');
    await store.dispatch(closeTimeoutPopup());

    const {markAsAuthenticated} = await import('../routes/Login/modules/login');
    await store.dispatch(markAsAuthenticated(false));

    return location.reload();
  },
  initDevice(phone_number, password, auth_token, device_guid){
    return promisifiedSocketEmit('/device/init_device', {phone_number, password, auth_token, device_guid})
  },
  updateDeviceSocket(){
    return createSecureEmit('/device/update');
  },
  getDeviceUser(){
    return createSecureEmit('/device/get_device_user');
  },
  getCategories() {
    return createSecureEmit('/device/categories');
  },
  getProducts(parent_category_id) {
    return createSecureEmit('/device/products', {parent_category_id});
  },
  getProductsByType(product_type) {
    return createSecureEmit('/device/products_by_type', {product_type});
  },
  getSingleProducts(){
    return createSecureEmit('/device/products_single');
  },
  getProductGwData(product_id) {
    return createSecureEmit('/device/gw_data', {product_id});
  },
  doBillerSearch(data) {
    return createSecureEmit('/utils/biller/search', {...data});
  },
  getFavoritesBillers() {
    return createSecureEmit('/utils/biller/favorites');
  },
  createSession(data) {
    return createSecureEmit('/session/create', {...data});
  },
  call(method_name, session_guid, data, update_session) {
    return createSecureEmit('/session/call', {method_name, session_guid, data, update_session});
  },
  setServerSession(session_guid, data) {
    return createSecureEmit('/session/set', {session_guid, data});
  },
  getEncodedSession() {
    return createSecureEmit('/session/encode');
  },
  completeSession(session_guid){
    return createSecureEmit('/session/complete', {session_guid});
  },
  initCustomer(session_guid, phone_number){
    return createSecureEmit('/customer/init', {session_guid, phone_number});
  },
  validatePhoneNumber(phone_number){
    return createSecureEmit('/utils/base/verify_phone_number', {phone_number});
  },
  loadShoppingCart(){
    return createSecureEmit('/cart/get');
  },
  removePayment(payment_id){
    return createSecureEmit('/cart/remove', {payment_id});
  },
  payPayments(payment_ids, received_amount){
    return createSecureEmit('/cart/pay', {payment_ids, received_amount});
  },
  getReports(startDate, endDate){
    return createSecureEmit('/utils/reports/get', {startDate, endDate});
  },
  generateReport(report_type, report_mode, startDate, endDate){
    return createSecureEmit('/utils/reports/create',
      {report_type, report_mode, startDate, endDate, utc_offset: -new Date().getTimezoneOffset(),});
  },
  getAutomaticReportConfig(){
    return createSecureEmit('/utils/reports/auto/get');
  },
  updateAutomaticReportConfig(enabled, options){
    return createSecureEmit('/utils/reports/auto/upsert', {enabled, options});
  },
  loadReportsDevices(){
    return createSecureEmit('/utils/reports/devices');
  },
  getTransaction(start_date, end_date){
    return createSecureEmit('/utils/transactions/get', {start_date, end_date});
  },
  cancelTransaction(payment_guid){
    return createSecureEmit('/utils/transactions/cancel', {payment_guid});
  },
  findAddress(request){
    return createSecureEmit('/utils/base/find_address', {request})
  },
  async printReceipt(receiptUrl, onLoadingStart, onLoadingEnd){
    if(!receiptUrl) return console.log('Receipt url not found');

    const soket = getSocket();

    const options = {
      printable: `${receiptUrl}/pdf`,
      type: 'pdf',
      onLoadingStart: () => {
        soket.disconnect();
        onLoadingStart()
      },
      onLoadingEnd: async() => {
        connectSocket();
        onLoadingEnd();
      },
      onError: async(error) => {
        alert(error);
        connectSocket();
        onLoadingEnd();
      }
    };

    printJS(options);
  },

  getClerksDevices(){
    return createSecureEmit('/management/get_clerk_devices');
  },

  getStoreClerks() {
    return createSecureEmit('/management/get_clerks');
  },

  updateClerkDevice(device_id, data) {
    return createSecureEmit('/management/update_clerk_device', {device_id, data})
  },

  createClerk(data) {
    return createSecureEmit('/management/create_clerk', data)
  },

  createDevice(data) {
    return createSecureEmit('/management/create_clerk_device', data)
  },

  changePasswordClerk(data) {
    return createSecureEmit('/management/change_clerk_password', data)
  },

  changePasswordStoreOwner(data) {
    return createSecureEmit('/management/change_owner_password', data)
  },

  editClerk(data) {
    return createSecureEmit('/management/update_clerk', data)
  },

  editOwner(data) {
    return createSecureEmit('/management/update_owner', data)
  }
};

const createSecureEmit = (path = '', params = {}) => promisifiedSocketEmit(path, {...MAYA.getCredentials(), ...params});

export default MAYA;



// WEBPACK FOOTER //
// ./src/maya_api/index.js